import React, { Component } from 'react';
import style from './BackDrop.module.css';

class BackDrop extends Component {


    // componentDidMount(){
    //     window.addEventListener('click', function(e){   
    //         if (document.getElementById('inside').contains(e.target)){
    //           // Clicked in box
    //           alert("clickin");
    //         } else{
    //           // Clicked outside the box
    //           alert("clickout");
    //         }
    //       });
    // }


   
    render() {
        
        let item = [];





        if(this.props.show === true){
            item.push(
                <div className={style.area} key={1} onClick={this.props.onClick}>
                    {/* <div className={style.loader}></div> */}
                    <div id="inside555">{this.props.children}</div>
                </div>
            );
        }
        return item;
    }
}
export default BackDrop;